import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './productCard.module.scss';

import {
  Markdown,
  Button as TitleTypography,
  Carousel,
  CarouselButtonType
} from '@huggg/react-components';

const ProductCard = props => {
  const {
    imageUrls,
    description,
    title,
    shadow,
    inSlider,
    children,
    centerText
  } = props;

  return (
    <div
      className={classnames(styles.productCard, {
        [styles.shadow]: shadow,
        [styles.inSlider]: inSlider
      })}
      data-test-id="product-card"
    >
      {imageUrls.length ? (
        <div
          className={imageUrls.length > 1 ? styles.images : styles.imagesNoDots}
        >
          <Carousel
            dots={imageUrls.length > 1}
            buttons={CarouselButtonType.Chevron}
            preview={false}
            isPlaying={false}
            interval={3000}
            dragEnabled={true}
          >
            {imageUrls.map((imageUrl, index) => (
              <div
                key={index}
                className={classnames(
                  styles.imageSlide,
                  styles.squareImageSlide
                )}
              >
                <img
                  src={imageUrl}
                  alt="preview of the product"
                  className={classnames(
                    styles.image,
                    styles.squareImage,
                    'image'
                  )}
                />
              </div>
            ))}
          </Carousel>
        </div>
      ) : null}

      {title || description ? (
        <>
          <div
            className={styles.copy}
            style={centerText && { textAlign: 'center' }}
          >
            <TitleTypography className={styles.title}>{title}</TitleTypography>
            <Markdown value={description} />
          </div>
        </>
      ) : null}

      {children}
    </div>
  );
};

ProductCard.defaultProps = {
  hidePoweredBy: false,
  shadow: false
};

ProductCard.propTypes = {
  imageUrls: PropTypes.array,
  description: PropTypes.string,
  title: PropTypes.string,
  shadow: PropTypes.bool,
  hidePoweredBy: PropTypes.bool,
  inSlider: PropTypes.bool,
  children: PropTypes.node,
  centerText: PropTypes.bool
};

export default ProductCard;
